import React from 'react';
import MuiDialog from "../../../atoms/muiDialog";
import {Button, Typography, Divider} from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import {css} from "@emotion/react";

// setting
import colorPalette from "../../../../styles/theme/colorPalette"
import {makeStyles} from "@material-ui/styles";

const Protein = () => {
  
  const [open, setOpen] = React.useState(false);
  
  const handleClose = (value) => {
    setOpen(false);
  };
  
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const useStyles = makeStyles({
    dialogPaper: {
      borderRadius: '24px',
      square: false
    },
  })
  
  const classes = useStyles()
  
  return (
      <>
        <HelpIcon color='primary' onClick={handleClickOpen} css={cursor}/>
        <MuiDialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='lg'
            css={dialogStyle}
            closeBtnColor={colorPalette.itemCategories.protein}
            classes={{paper: classes.dialogPaper}}>
          <div css={innerBox}>
            <hr css={style}/>
            <p css={title}>たんぱく質調整食</p>
            <p css={subTitle}>
              腎臓病食、糖尿病性腎症食としても<br/>
              お召し上がりいただけるように栄養士が開発
            </p>
            <hr css={style}/>
            <div css={comment}>
              たんぱく質・カリウム・リン・塩分を抑えたお食事で、全ての商品でたんぱく質を10.0g未満に、塩分を2.0g以下に調整してあります。
              たんぱく質・カリウム・リン・塩分の摂取を控える必要のある腎臓病・糖尿病性腎症の方におすすめです。
            </div>
          </div>
        </MuiDialog>
      </>
  );
};

export default Protein;

const dialogStyle = css`
  border-radius: 16px;
`

const cursor = css`
  cursor: pointer;
`

const style = css`
  border-top: solid 1px ${colorPalette.itemCategories.protein};
`

const title = css`
  font-size: 32px;
  margin-bottom: 16px;
  text-align: center;
  color: ${colorPalette.itemCategories.protein};
`

const subTitle = css`
  font-size: 24px;
  text-align: center;
  color: ${colorPalette.itemCategories.protein};
`

const innerBox = css`
  max-width: 640px;
  padding: 32px 24px;
  margin: 16px auto 0;
`
const comment = css`
  margin-top: 24px;
`